import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Inject, Output, NgModule } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { tuiGetViewportWidth } from '@taiga-ui/core';
import * as i1 from '@taiga-ui/cdk';
import { TuiRepeatTimesModule } from '@taiga-ui/cdk';
import { CommonModule } from '@angular/common';

const MAX_COLS_NUMBER = 15;
const MAX_ROWS_NUMBER = 15;
const MIN_DISTANCE_PX = 70;
class TuiTableSizeSelectorComponent {
    constructor(win) {
        this.win = win;
        this.selectSize = new EventEmitter();
        /**
         * @deprecated use {@link selectSize}
         * TODO: remove in v4.0
         */
        this.onSelectSize = this.selectSize;
        this.tableSize = {
            rows: 1,
            cols: 1,
        };
    }
    get columnsNumber() {
        return Math.min(Math.max(3, this.tableSize.cols + 1), MAX_COLS_NUMBER);
    }
    get rowsNumber() {
        return Math.min(Math.max(3, this.tableSize.rows + 1), MAX_ROWS_NUMBER);
    }
    tableSelectHovered(x, y) {
        return x < this.tableSize.rows && y < this.tableSize.cols;
    }
    updateCurrentSize(rows, cols, event) {
        if (tuiGetViewportWidth(this.win) - event.clientX > MIN_DISTANCE_PX) {
            this.tableSize = { rows, cols };
        }
    }
    /**
     * @deprecated use {@link select}
     * TODO: remove in v4.0
     */
    onClick() {
        this.select();
    }
    select() {
        this.selectSize.emit(this.tableSize);
    }
}
TuiTableSizeSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableSizeSelectorComponent, deps: [{ token: WINDOW }], target: i0.ɵɵFactoryTarget.Component });
TuiTableSizeSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiTableSizeSelectorComponent, selector: "tui-table-size-selector", outputs: { selectSize: "selectSize", onSelectSize: "onSelectSize" }, ngImport: i0, template: "<div\n    *tuiRepeatTimes=\"let x of columnsNumber\"\n    class=\"t-column\"\n>\n    <div\n        *tuiRepeatTimes=\"let y of rowsNumber\"\n        class=\"t-cell\"\n        [class.t-cell_hovered]=\"tableSelectHovered(y, x)\"\n        (mouseenter)=\"updateCurrentSize(y + 1, x + 1, $event)\"\n        (click)=\"select()\"\n    ></div>\n</div>\n<div class=\"t-description\">{{ tableSize.cols }}&#215;{{ tableSize.rows }}</div>\n", styles: [":host{display:block;padding:.75rem}.t-cell{display:inline-block;background-color:var(--tui-base-01);width:1.25rem;height:1.25rem;border-radius:.25rem;margin:.125rem;border:1px solid var(--tui-base-04);cursor:pointer}.t-cell_hovered{background-color:var(--tui-base-02)}.t-column{white-space:nowrap}.t-description{text-align:center}\n"], directives: [{ type: i1.TuiRepeatTimesDirective, selector: "[tuiRepeatTimes][tuiRepeatTimesOf]", inputs: ["tuiRepeatTimesOf"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableSizeSelectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-table-size-selector',
                    templateUrl: './table-size-selector.template.html',
                    styleUrls: ['./table-size-selector.style.less'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: Window, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }]; }, propDecorators: { selectSize: [{
                type: Output
            }], onSelectSize: [{
                type: Output
            }] } });

class TuiTableSizeSelectorModule {
}
TuiTableSizeSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableSizeSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiTableSizeSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableSizeSelectorModule, declarations: [TuiTableSizeSelectorComponent], imports: [CommonModule, TuiRepeatTimesModule], exports: [TuiTableSizeSelectorComponent] });
TuiTableSizeSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableSizeSelectorModule, imports: [[CommonModule, TuiRepeatTimesModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableSizeSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TuiRepeatTimesModule],
                    declarations: [TuiTableSizeSelectorComponent],
                    exports: [TuiTableSizeSelectorComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTableSizeSelectorComponent, TuiTableSizeSelectorModule };
